import {NgModule, ModuleWithProviders} from '@angular/core';
import {NzMenuModule} from 'ng-zorro-antd/menu'
import {CommonModule} from '@angular/common';
import {NzIconModule} from 'ng-zorro-antd/icon';
import {HttpClientModule} from '@angular/common/http';
import {NzTreeModule} from 'ng-zorro-antd/tree'
import {NzFormModule} from 'ng-zorro-antd/form'
import {ReactiveFormsModule} from '@angular/forms'
import {NzCardModule} from 'ng-zorro-antd/card'
import {NzButtonModule} from 'ng-zorro-antd/button';
import {NzTableModule} from 'ng-zorro-antd/table'
import {NzInputModule} from 'ng-zorro-antd/input'
import {MmIconModule} from '../icon';
import {MmI18nModule, TRANSLATION_GROUP_TOKEN} from '../i18n';
import {MmTableModule} from 'mm-web-core/table';
import {NzSelectModule} from 'ng-zorro-antd/select'
import {TranslationGroup} from 'mm-web-core/i18n/tanslation-group';
import {NzModalModule} from 'ng-zorro-antd/modal';
import {MmLanguageManagementComponent} from "./components/language-management/language-management.component";
import {mmMenuConstants} from "../menu/menu-constants";
import {en, zh} from "./i18n";
import {mmLanguageConstants} from "./language-constants";


@NgModule({
  imports: [
    NzMenuModule,
    CommonModule,
    NzIconModule,
    HttpClientModule,
    NzTreeModule,
    NzFormModule,
    ReactiveFormsModule,
    NzCardModule,
    NzButtonModule,
    NzTableModule,
    MmIconModule,
    MmI18nModule,
    NzInputModule,
    MmTableModule,
    NzSelectModule,
    NzModalModule
  ],
  declarations: [
    MmLanguageManagementComponent
  ],
  exports: [
    MmLanguageManagementComponent
  ],
  providers: [],
})
export class MmLanguageModule {
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: MmLanguageModule,
      providers: [
        {
          provide: TRANSLATION_GROUP_TOKEN,
          useValue: {
            groupName: mmLanguageConstants.translationGroup,
            translations: {
              "en": en,
              "zh": zh
            }

          } as TranslationGroup,
          multi: true
        }
      ]
    }

  }
}
